import styled from "styled-components";

export const RecentWrapper = styled.div`
  min-height: 713px;
  background-color: #fff;
  color: #fff;
  padding-top: 96px;
  padding-bottom: 56px;
  @media (max-width: 960px) {
    padding-top: 60px;
    padding-bottom: 40px;
  }
`;
